import MutationObserver from 'mutation-observer';
import GlobalMenuContainer from './global-menu-container';
import GlobalServicesMenuButton from './global-services-menu-button';
import GlobalSitesMenuButton from './global-sites-menu-button';
import GlobalSupportMenu from './global-menu-support';
import GlobalAccountMenu from './global-account-menu';
import GlobalContextSwitcherButton from './global-context-switcher-button';
import camContextSwitcherDatastore from '../cam-context-switcher/scripts/cam-context-switcher-datastore';
import { eventContextChanged } from '../cam-context-switcher/scripts/cam-context-switcher-constants';

import { PROD_ENVIRONMENT, URL_CONFIG } from './defaults';


export default {

  menu: null,
  servicesMenu: null,
  sitesMenu: null,
  supportMenu: null,
  accountMenu: null,
  mutationObserver: null,
  services: null,
  sites: null,
  camContext: null,

  version: GLOBAL_MENUS_VERSION,

  initialize: function(env, urls) {
    let environment = env || PROD_ENVIRONMENT;
    const camContext = this.processContextQueryParams();

    if (env === 'CUSTOM') {
      environment = 'BETA';
    }

    return fetch(URL_CONFIG[environment])
      .then((response) => response.json())
      .then((config) => {
        if (env === 'CUSTOM') {
          if (typeof urls !== 'undefined') {

            config.sites.ACT.url = 'https://account.' + urls.domain;
            config.sites.ALM.url = 'https://' + urls.domain;

            if (typeof urls.monitoring !== 'undefined') {
              config.sites.MON.url = urls.monitoring;
            } else {
              config.sites.MON.url = 'https://monitoring.' + urls.domain;
            }

            if (typeof urls.analytics !== 'undefined') {
              config.sites.OPT.url = urls.analytics;
            } else {
              config.sites.OPT.url = 'https://analytics.' + urls.domain;
            }

            config.sites.SDW.url = 'https://sdwan.' + urls.domain;
          }
        }

        this.processConfiguration(config);
        this.initializeMenuElement();

        this.initializeServicesMenu();
        this.initializeSitesMenu();

        this.initializeSupportMenu();
        this.initializeAccountMenu();
        this.initializeContextSwitcher(camContext);

        document.addEventListener(eventContextChanged, this.refreshSitesMenu.bind(this));

        if (!this.mutationObserver && (!this.menu || !this.accountMenu || !this.servicesMenu || !this.sitesMenu || !this.supportMenu || !this.contextSwitcher)) {
          this.observe();
        }
      })
      .catch((error) => {
        throw(`[GlobalMenus] There was a problem loading configuration from ${URL_CONFIG[environment]} - Error: ${error}`);
      });
  },

  processConfiguration(config) {
    this.services = config.services;
    this.sites = config.sites;
  },

  refreshSitesMenu() {
    this.datastore = camContextSwitcherDatastore;
    let selectedContextType;
    let selectedContext;
    let queryParamString = '';

    if(this.datastore.selectedContext && this.datastore.selectedContext.context) {
      selectedContextType = this.datastore.selectedContext.context.type;
      if(selectedContextType.includes('workspace')) {
        selectedContextType = 'workspace';
      }
      selectedContext = this.datastore.selectedContext.context.id;
      queryParamString = `?cam-context-type=${selectedContextType}&cam-context-id=${selectedContext}`;
    }

    this.sites = Object.keys(this.sites).reduce((memo, curr) => {
      if (! this.sites[curr].baseUrl) {
        this.sites[curr].baseUrl = this.sites[curr].url;
      }
      let current = this.sites[curr];
      let url = `${this.sites[curr].baseUrl}${queryParamString}`;
      current.url = url;
      memo[curr] = current;
      return memo;
    }, {});
    this.initializeSitesMenu();
  },

  processContextQueryParams: function() {
    let queryParams = new URLSearchParams(window.location.search);
    let camContextType = queryParams.get('cam-context-type');
    let camContextId = queryParams.get('cam-context-id');
    if (camContextType && camContextId) {
      this.camContext = {
        type: camContextType,
        id: camContextId
      };
      queryParams.delete('cam-context-type');
      queryParams.delete('cam-context-id');
      let params = queryParams.toString() === '' ? '' : `?${queryParams.toString()}`;
      window.history.pushState({}, '', `${window.location.origin}${window.location.pathname}${params}${window.location.hash}`);
    }

    return {
      camContext: this.camContext
    };
  },

  initializeMenuElement: function() {
    if (this.menu) {
      return this.menu;
    }

    const globalMenuElement = document.querySelector('global-menu-container');

    if (globalMenuElement) {
      const options = globalMenuElement.dataset;
      const globalMenuContainer = new GlobalMenuContainer(globalMenuElement, options);
      this.menu = globalMenuContainer;

      return this.menu;
    }

    return false;
  },

  initializeServicesMenu: function() {
    if (this.servicesMenu) {
      return this.servicesMenu;
    }

    const globalServicesMenuElement = document.querySelector('global-services-menu-button');

    if (globalServicesMenuElement && this.menu) {
      const options = globalServicesMenuElement.dataset;
      const globalServicesMenuButton = new GlobalServicesMenuButton(this.menu, globalServicesMenuElement, options, this.services);
      this.servicesMenu = globalServicesMenuButton;

      return this.servicesMenu;
    }

    return false;
  },

  initializeSitesMenu: function() {
    if (this.sitesMenu) {
      return this.sitesMenu;
    }

    const globalSitesMenuElement = document.querySelector('global-sites-menu-button');

    if (globalSitesMenuElement && this.menu) {
      const options = globalSitesMenuElement.dataset;
      const globalSitesMenuButton = new GlobalSitesMenuButton(this.menu, globalSitesMenuElement, options, this.sites);
      this.sitesMenu = globalSitesMenuButton;

      return this.sitesMenu;
    }

    return false;
  },

  initializeContextSwitcher: function(camContext) {

    if (this.contextSwitcher) {
      return this.contextSwitcher;
    }

    const globalContextSwitcherElement = document.querySelector('global-context-switcher-button');
    if (globalContextSwitcherElement && this.menu) {
      const options = globalContextSwitcherElement.dataset;
      const globalContextSwitcher = new GlobalContextSwitcherButton(this.menu, globalContextSwitcherElement, options, camContext);
      this.contextSwitcher = globalContextSwitcher;

      return this.contextSwitcher;
    }

    return false;
  },

  initializeSupportMenu: function() {
    if (this.supportMenu) {
      return this.supportMenu;
    }

    const globalSupportMenuElement = document.querySelector('global-menu-support');
    if (globalSupportMenuElement) {
      const options = globalSupportMenuElement.dataset;
      const globalSupportMenu = new GlobalSupportMenu(globalSupportMenuElement, options);
      this.supportMenu = globalSupportMenu;

      return this.supportMenu;
    }

    return false;
  },

  initializeAccountMenu: function() {
    if (this.accountMenu) {
      return this.accountMenu;
    }

    const globalAccountMenuElement = document.querySelector('global-account-menu');
    if (globalAccountMenuElement) {
      const options = globalAccountMenuElement.dataset;
      const globalAccountMenu = new GlobalAccountMenu(globalAccountMenuElement, options);
      this.accountMenu = globalAccountMenu;

      return this.accountMenu;
    }

    return false;
  },

  populateContextSwitcher: function(token, config={}) {
    let camContextSwitcher = document.querySelector('#cam-context-switcher');
    if (camContextSwitcher) {
      return camContextSwitcher.populate(token, config);
    } else {
      return Promise.reject(Error('#cam-context-switcher is not present in document'));
    }
  },

  destroy: function(removeElements = true) {
    this.removeMenu(removeElements);
    this.removeServicesMenu(removeElements);
    this.removeSitesMenu(removeElements);
    this.removeSupportMenu(removeElements);
    this.removeAccountMenu(removeElements);

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  },

  removeMenu: function(removeElement = true) {
    if (!this.menu) { return; }
    this.menu.destroy();
    this.menu = null;

    if (removeElement) {
      const globalMenuElement = document.querySelector('global-menu-container');
      if (globalMenuElement) {
        globalMenuElement.parentNode.removeChild(globalMenuElement);
      }
    }
  },

  removeServicesMenu: function(removeElement = true) {
    if (!this.servicesMenu) { return; }
    this.servicesMenu.destroy();
    this.servicesMenu = null;

    if (removeElement) {
      const globalServicesMenuButtonElement = document.querySelector('global-services-menu-button');
      if (globalServicesMenuButtonElement) {
        globalServicesMenuButtonElement.parentNode.removeChild(globalServicesMenuButtonElement);
      }
    }
  },

  removeSitesMenu: function(removeElement = true) {
    if (!this.sitesMenu) { return; }
    this.sitesMenu.destroy();
    this.sitesMenu = null;

    if (removeElement) {
      const globalSitesMenuButtonElement = document.querySelector('global-sites-menu-button');
      if (globalSitesMenuButtonElement) {
        globalSitesMenuButtonElement.parentNode.removeChild(globalSitesMenuButtonElement);
      }
    }
  },

  removeContextSwitcher: function(removeElement = true) {
    if (!this.contextSwitcher) { return; }
    this.contextSwitcher.destroy();
    this.contextSwitcher = null;

    if (removeElement) {
      const globalContextSwitcherButtonElement = document.querySelector('global-context-switcher-button');
      if (globalContextSwitcherButtonElement) {
        globalContextSwitcherButtonElement.parentNode.removeChild(globalContextSwitcherButtonElement);
      }
    }
  },

  removeSupportMenu: function(removeElement = true) {
    if (!this.supportMenu) { return; }
    this.supportMenu.destroy();
    this.supportMenu = null;

    if (removeElement) {
      const globalSupportMenuElement = document.querySelector('global-menu-support');
      if (globalSupportMenuElement) {
        globalSupportMenuElement.parentNode.removeChild(globalSupportMenuElement);
      }
    }
  },

  removeAccountMenu: function(removeElement = true) {
    if (!this.accountMenu) { return; }
    this.accountMenu.destroy();
    this.accountMenu = null;

    if (removeElement) {
      const gloubalAccountMenuElement = document.querySelector('global-account-menu');
      if (gloubalAccountMenuElement) {
        gloubalAccountMenuElement.parentNode.removeChild(gloubalAccountMenuElement);
      }
    }
  },

  observe() {
    const observerOptions = {
      subtree: true,
      attributes: false,
      childList: true,
      characterData: false
    };
    const observedTagNames = [
      'GLOBAL-MENU-CONTAINER', 'GLOBAL-SERVICES-MENU-BUTTON',
      'GLOBAL-SITES-MENU-BUTTON', 'GLOBAL-MENU-SUPPORT',
      'GLOBAL-ACCOUNT-MENU', 'GLOBAL-CONTEXT-SWITCHER-BUTTON'
    ];

    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {

        // Additions
        const addedNodes = [].slice.call(mutation.addedNodes);
        addedNodes.forEach((addedNode) => {
          const tagNameMatches = (observedTagNames.indexOf(addedNode.tagName) >= 0);
          const selectorMatches = (addedNode.querySelector && addedNode.querySelector(observedTagNames));

          if (tagNameMatches || selectorMatches) {
            this.initialize();
          }
        });

        // Removals
        const removedNodes = [].slice.call(mutation.removedNodes);
        removedNodes.forEach((removedNode) => {
          const tagNameMatches = (observedTagNames.indexOf(removedNode.tagName) >= 0);
          const selectorMatches = (removedNode.querySelectorAll && removedNode.querySelectorAll(observedTagNames));

          if (tagNameMatches) {
            this._handleElementRemoval(removedNode);
          } else if (selectorMatches) {
            const selectorMatchesArray = [].slice.call(selectorMatches);
            selectorMatchesArray.forEach((matchedNode) => {
              this._handleElementRemoval(matchedNode);
            });
          }
        });

      });
    });

    this.mutationObserver.observe(document, observerOptions);
  },

  _handleElementRemoval: function(element) {
    switch(element.tagName) {
    case 'GLOBAL-MENU-CONTAINER':
      this.removeMenu(false);
      break;
    case 'GLOBAL-SERVICES-MENU-BUTTON':
      this.removeServicesMenu(false);
      break;
    case 'GLOBAL-SITES-MENU-BUTTON':
      this.removeSitesMenu(false);
      break;
    case 'GLOBAL-MENU-SUPPORT':
      this.removeSupportMenu(false);
      break;
    case 'GLOBAL-ACCOUNT-MENU':
      this.removeAccountMenu(false);
      break;
    case 'GLOBAL-CONTEXT-SWITCHER-BUTTON':
      this.removeContextSwitcher(false);
      break;
    default:
      throw(`[GlobalMenus] Asked to remove an unknown element type: ${element.tagName}!`);
    }
  }

};



// WEBPACK FOOTER //
// ./src/scripts/global-menus.js